/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { UserAccountType } from './UserAccountType';
import {
    UserAccountTypeFromJSON,
    UserAccountTypeFromJSONTyped,
    UserAccountTypeToJSON,
} from './UserAccountType';
import type { UserStateOfUse } from './UserStateOfUse';
import {
    UserStateOfUseFromJSON,
    UserStateOfUseFromJSONTyped,
    UserStateOfUseToJSON,
} from './UserStateOfUse';

/**
 * 
 * @export
 * @interface CreateUpdateUserDto
 */
export interface CreateUpdateUserDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    middleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    emailAddress: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    profilePictureId?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateUpdateUserDto
     */
    assignedRoles?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    description?: string | null;
    /**
     * 
     * @type {UserAccountType}
     * @memberof CreateUpdateUserDto
     */
    accountType?: UserAccountType;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    mobileNumber?: string | null;
    /**
     * 
     * @type {UserStateOfUse}
     * @memberof CreateUpdateUserDto
     */
    state?: UserStateOfUse;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateUserDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateUpdateUserDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    $type?: CreateUpdateUserDtoTypeEnum;
}


/**
 * @export
 */
export const CreateUpdateUserDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAuthorizationUsersDtoCreateUpdateUserDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Users.Dto.CreateUpdateUserDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateUpdateUserDtoTypeEnum = typeof CreateUpdateUserDtoTypeEnum[keyof typeof CreateUpdateUserDtoTypeEnum];


/**
 * Check if a given object implements the CreateUpdateUserDto interface.
 */
export function instanceOfCreateUpdateUserDto(value?: unknown): value is CreateUpdateUserDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateUpdateUserDtoTypeEnum)[0];
}

export function CreateUpdateUserDtoFromJSON(json: any): CreateUpdateUserDto {
    return CreateUpdateUserDtoFromJSONTyped(json, false);
}

export function CreateUpdateUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'middleName': !exists(json, 'middleName') ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'emailAddress': json['emailAddress'],
        'profilePictureId': !exists(json, 'profilePictureId') ? undefined : json['profilePictureId'],
        'assignedRoles': !exists(json, 'assignedRoles') ? undefined : json['assignedRoles'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'accountType': !exists(json, 'accountType') ? undefined : UserAccountTypeFromJSON(json['accountType']),
        'mobileNumber': !exists(json, 'mobileNumber') ? undefined : json['mobileNumber'],
        'state': !exists(json, 'state') ? undefined : UserStateOfUseFromJSON(json['state']),
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateUpdateUserDtoToJSON(value?: CreateUpdateUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'firstName': value.firstName,
        'middleName': value.middleName,
        'lastName': value.lastName,
        'phoneNumber': value.phoneNumber,
        'emailAddress': value.emailAddress,
        'profilePictureId': value.profilePictureId,
        'assignedRoles': value.assignedRoles,
        'title': value.title,
        'description': value.description,
        'accountType': UserAccountTypeToJSON(value.accountType),
        'mobileNumber': value.mobileNumber,
        'state': UserStateOfUseToJSON(value.state),
        'lastModificationTime': value.lastModificationTime,
        'isAvailable': value.isAvailable,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'iuid': value.iuid,
        '$type': value.$type,
    });
}

